import { render, staticRenderFns } from "./editGoodsInfoDialog.vue?vue&type=template&id=14b22ae4"
import script from "./editGoodsInfoDialog.vue?vue&type=script&lang=js"
export * from "./editGoodsInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports